import { render, staticRenderFns } from "./courseAdjustmentAdd.vue?vue&type=template&id=2ebacfaa&scoped=true"
import script from "./courseAdjustmentAdd.vue?vue&type=script&lang=js"
export * from "./courseAdjustmentAdd.vue?vue&type=script&lang=js"
import style0 from "./courseAdjustmentAdd.vue?vue&type=style&index=0&id=2ebacfaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebacfaa",
  null
  
)

export default component.exports